module.exports = __webpack_public_path__ + "static/media/maki-marker-stroked-15-4.3d0b111c.svg";